/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import React, { useState, useEffect } from 'react';
import anyErrors from '../../common/helpers/anyErrors';
import createObjectWithSameKeys from '../../common/helpers/createObjectWithSameKeys';
import validateForm from './validateMetaDataFormValues';
import MetaDataStepDisplay from './MetaDataStepDisplay';

const initialFormValues = {
  dealType: undefined,
  clientName: '',
  projectName: '',
  restriction: undefined,
  target: '',
  industryId: undefined,
  targetIndustryId: undefined,
  consentLevel: 'None',
  isClientTarget: null,
  classification: 'Yes',
  lineOfService: 'Advisory Services (AS)', // TODO: GLI set to ''
};

const initialFormErrors = createObjectWithSameKeys(initialFormValues, '');
const initialFormTouches = createObjectWithSameKeys(initialFormValues, false);

const MetaDataStep = ({
  initialValues = {},
  onCancel,
  onStepCompleted,
  isSaving,
}) => {
  const [formValues, setFormValues] = useState({
    ...initialFormValues,
    ...initialValues,
  });
  const [formTouches, setFormTouches] = useState(initialFormTouches);
  const [formErrors, setFormErrors] = useState(initialFormErrors);
  const [isValid, setIsValid] = useState(false);

  const validateWrap = (values) => {
    const updatedFormErrors = validateForm(values);
    setFormErrors(updatedFormErrors);
    setIsValid(!anyErrors(updatedFormErrors));
  };

  useEffect(() => {
    validateWrap(formValues);
  }, [formValues]);

  const onChange = (event) => {
    const { name, value } = event.target;
    const updatedFormValues = { ...formValues, [name]: value };
    setFormValues(updatedFormValues);
    validateWrap(updatedFormValues);
  };

  const onBlur = (fieldName) => () => {
    setFormTouches({ ...formTouches, [fieldName]: true });
  };

  const onNextClick = () => {
    onStepCompleted(formValues);
  };

  return (
    <MetaDataStepDisplay
      formValues={formValues}
      formTouches={formTouches}
      formErrors={formErrors}
      isValid={isValid}
      setIsValid={setIsValid}
      onChange={onChange}
      onBlur={onBlur}
      onNextClick={onNextClick}
      onCancel={onCancel}
      isSaving={isSaving}
    />
  );
};

export default MetaDataStep;
